// extracted by mini-css-extract-plugin
export default {"title":"Banner_title__VFORL","description":"Banner_description__6wddW"};